import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

export default function CommitteeMembers({ isPage = false }) {
  const navigate = useNavigate();
  const API = process.env.PARCEL_API_URL;

  const [members, setMembers] = useState([]);
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  const cardWidth = 260;

  // 🔥 FETCH
  useEffect(() => {
    if (!API) return;

    axios
      .get(`${API}/api/committee`)
      .then((res) => setMembers(res.data || []))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [API]);

  // 🔥 DUPLICATE FOR LOOP
  const loopMembers = [...members, ...members];

  // 🔥 AUTO SLIDE
  useEffect(() => {
    if (members.length === 0) return;

    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, [members]);

  // 🔥 RESET LOOP
  useEffect(() => {
    if (index >= members.length) {
      setIndex(0);
    }
  }, [index, members.length]);

  // 🔥 SKELETON CARD
  const SkeletonCard = () => (
    <div className="min-w-[250px] bg-white rounded-2xl shadow-md overflow-hidden animate-pulse">
      <div className="h-52 bg-gray-300"></div>
      <div className="p-4">
        <div className="h-4 bg-gray-300 rounded w-2/3 mx-auto mb-2"></div>
        <div className="h-3 bg-gray-300 rounded w-1/2 mx-auto"></div>
      </div>
    </div>
  );

  return (
    <section className="px-6 md:px-24 py-16 bg-orange-50 overflow-hidden">

      {/* 🔙 BACK */}
      {isPage && (
        <button
          onClick={() => navigate("/")}
          className="mb-6 text-orange-500 font-semibold hover:underline"
        >
          ← Back to Home Page
        </button>
      )}

      {/* 🔥 TITLE */}
      <h2 className="text-3xl font-bold text-center mb-10">
        Committee <span className="text-orange-500">Members</span>
      </h2>

      {/* 🔥 CONTENT */}
      <div className="relative overflow-hidden">

        {/* 🔥 SKELETON (FIXED 4 CARDS ROW) */}
        {loading ? (
          <div className="flex gap-6 justify-center">
            {Array(4)
              .fill(0)
              .map((_, i) => (
                <SkeletonCard key={i} />
              ))}
          </div>
        ) : (

          /* 🔥 CAROUSEL */
          <motion.div
            className="flex gap-6"
            animate={{ x: `-${index * cardWidth}px` }}
            transition={{ ease: "linear", duration: 0.6 }}
          >
            {loopMembers.map((member, i) => (
              <div
                key={member._id + i}
                className="min-w-[250px] relative rounded-2xl overflow-hidden shadow-lg group cursor-pointer"
              >
                {/* IMAGE */}
                <div className="h-52 overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                  />
                </div>

                {/* OVERLAY */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                {/* CONTENT */}
                <div className="absolute bottom-0 w-full px-4 py-3 text-center">
                  <h4 className="text-white text-lg font-semibold mb-1">
                    {member.name}
                  </h4>

                  <p className="text-orange-400 text-sm font-medium">
                    {member.role}
                  </p>
                </div>

                {/* BORDER */}
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-orange-400 rounded-2xl transition"></div>
              </div>
            ))}
          </motion.div>
        )}

      </div>
    </section>
  );
}